module.exports = __webpack_public_path__ + "./fonts/36b5bab58a18b9c924861a4ccbf1a790.ttf";